import React, { useState } from "react";
import { getIcons } from "../Constant/Constant";
import Loader from "../Constant/Loader";
import { useNavigate } from "react-router-dom";
import { interestLevel } from "../../Enum";

const StatusWiseAllLeads = ({
  leads,
  fetchLeadsData,
  nextPageToken,
  prevPageToken,
  totalLead,
  currentPage,
}) => {
  const icons = getIcons();
  const [loading, setLoading] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();
  const noLeads = leads.length === 0;
  const hasMoreLeads = nextPageToken !== null;

  console.log("Total Lead", totalLead);

  const statusIcons = Object.freeze({
    Fresh: icons.freshIcon,
    "Registered Client": icons.registeredClient,
    "Follow-up": icons.interestedIcon,
    Dealing: icons.dealingIcon,
    "Deal Lost": icons.dealLostIcon,
    "Not Interested": icons.notInterestedIcon,
    Unanswered: icons.unansweredIcon,
    "Retry Suitable": icons.RetrySuitable,
  });
  

  const leadCharacterEmoji = Object.freeze({
    "Not Applicable": icons.NAEmoji,
    None: icons.NAEmoji,
    Excited: icons.excitedEmoji,
    Neutral: icons.neutralEmoji,
    Thinking: icons.ThinkingEmoji,
    Confused: icons.confusedEmoji,
  });

  const calculateLastAct = (lastModifiedTime) => {
    const lastModifiedDate = new Date(lastModifiedTime);
    const currentDate = new Date();
    const timeDiff = Math.abs(currentDate - lastModifiedDate);
    const diffDays = Math.ceil(timeDiff / (1000 * 60 * 60 * 24)) - 1;
    return diffDays;
  };

  const getDaysStyle = (days) => {
    if (days < 5) return "text-sky-500";
    if (days >= 5 && days <= 10) return "text-yellow-500";
    return "text-red-500";
  };

  const formatDaysText = (days) => (days === 1 ? "Day" : "Days");

  const handleLeadInfo = (lead) => {
    let path = `/admin/lead-info/${lead.docId}`;
    navigate(path, { state: { lead } });
  };

  
  const filteredLeads = leads.filter((lead) => {
    return (
      lead?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
      String(lead?.phoneNumber || "").includes(searchQuery) 
    );
  });
  

  const handlePageChange = (token, direction) => {
    if (!token) return;
    setLoading(true);
    fetchLeadsData(token, direction).finally(() => setLoading(false));
  };
  const getBackgroundClass = (label) => {
    switch (label) {
      case "Gold":
        return "bg-gradient-to-b from-[#FFB947] to-[#ECCD90] bg-clip-text text-transparent";
      case "Silver":
        return "bg-gradient-to-b from-[#B6B6B6] to-[#E8E8E8] bg-clip-text text-transparent";
      case "Bronze":
        return "bg-gradient-to-b from-[#BA7E5E] via-[#FF9F6B] to-[#411904] bg-clip-text text-transparent";
      case "Diamond":
        return "bg-gradient-to-b from-[#0563FF] to-[#4085F8] bg-clip-text text-transparent";
      default:
        return "text-black";
    }
  };

  return (
    <div className="w-full shadow-md rounded-md py-4 px-4 h-[680px] pb-9 bg-white">
      {loading && <Loader />}
      <div className="flex flex-col gap-5">
        <div className="flex justify-between items-center">
          <h1 className="text-3xl font-semibold ml-5">
            All Leads &#40;
            {totalLead !== undefined
              ? totalLead
              : searchQuery !== ""
              ? leads.length
              : 0}
            &#41;
          </h1>
        </div>
        <div>
          <input
            className="border-customGreen rounded-md border bg-transparent w-11/12 h-10 px-4 mx-5 focus:outline-none"
            placeholder="Search by name or phone number"
            type="search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
      </div>

      <div className="custom-scrollbar h-[500px] overflow-y-auto py-7 px-5">
        {filteredLeads.length === 0 ? (
          <div className="text-center text-gray-500 text-xl font-semibold mt-10">
            No Leads Available
          </div>
        ) : (
          filteredLeads.map((lead) => (
            <div
              onClick={() => handleLeadInfo(lead)}
              key={lead.id}
              className="grid grid-cols-2 gap-4 px-10 py-2  xl:px-5 mt-5 rounded-lg shadow-md cursor-pointer"
            >
              <div className=" grid w-4/12 text-ellipsis xl:w-full ">
                <h1
                  title={lead.name}
                  className="text-xl font-bold pt-3 text-ellipsis whitespace-nowrap xl:text-base 4xl:text-2xl truncate "
                >
                  {lead.name.replace(/\b\w/g, (char) => char.toUpperCase())}
                </h1>

                <p className="font-medium  ">
                  Team:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead.assignedTeam}
                  </span>
                </p>
                <p className="font-medium  ">
                  Assigned User:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead.assignedUser}
                  </span>
                </p>
                <p className="font-medium flex items-center space-x-1">
                  <span>Locations:</span>
                  <span title={lead.interestedLocations[0]} className="font-medium 4xl:text-lg w-[120px] truncate overflow-hidden whitespace-nowrap">
                    {lead.interestedLocations[0] || "No Location"}
                  </span>
                  {lead.interestedLocations.length > 1 && (
                    <span className="text-blue-500 font-semibold">
                      +{lead.interestedLocations.length - 1}
                    </span>
                  )}
                </p>

                {lead?.leadQuality ? (
                  <div className="flex items-center gap-2 ">
                    <img
                      src={
                        interestLevel.find(
                          (level) => level?.label === lead.leadQuality
                        )?.image
                      }
                      alt={
                        interestLevel.find(
                          (level) => level?.label === lead.leadQuality
                        )?.label
                      }
                    />
                    <div
                      className={`${getBackgroundClass(
                        lead?.leadQuality
                      )} font-semibold`}
                    >
                      {lead?.leadQuality == "None" ? "" : lead.leadQuality}
                    </div>
                  </div>
                ) : (
                  " "
                )}
                {/* <p className="font-medium  ">
                  Created date:{" "}
                  <span className="font-medium 4xl:text-lg whitespace-nowrap truncate">
                    {lead?.createdTime}
                  </span>
                </p> */}
              </div>

              <div className="grid grid-cols-3 gap-14 pt-4 4xl:text-lg xl:text-sm">
                <div className="flex flex-col items-center w-auto pt-2 justify-center ">
                  <img
                    className=" xl:w-12 4xl:w-12"
                    src={statusIcons[lead.status]}
                    alt={lead.status}
                  />
                  <p className="font-medium whitespace-nowrap truncate ">
                    {lead.status}
                  </p>
                </div>

                <div className="flex flex-col items-center w-auto justify-center  ">
                  <div className="">
                    <span
                      className={`text-2xl mr-1 4xl:text-5xl ${getDaysStyle(
                        calculateLastAct(lead.lastModifiedTime)
                      )}`}
                    >
                      {calculateLastAct(lead.lastModifiedTime)}
                      {console.log("Number 2  " + lead.lastModifiedTime)}
                    </span>
                    <span className="text-base text-gray-500 ">
                      {formatDaysText(calculateLastAct(lead.lastModifiedTime))}

                      {console.log("Number 1  " + lead.lastModifiedTime)}
                    </span>
                  </div>
                  <p className="whitespace-nowrap">Last act</p>
                </div>

                <div className="flex flex-col items-center w-auto  pt-2 justify-center ">
                  <img
                    className=" xl:w-8 4xl:w-12"
                    src={leadCharacterEmoji[lead.leadCharacter]}
                    alt={lead.leadCharacter}
                  />
                  <p className="">Type</p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      <div className="flex justify-center gap-10 mt-4">
        {prevPageToken && currentPage > 1 && (
          <button
            onClick={() => handlePageChange(prevPageToken, "previous")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img
              src={icons.previousPagination}
              className="w-3"
              alt="Previous"
            />
          </button>
        )}

        <span>{currentPage}</span>

        {nextPageToken && currentPage * 10 < totalLead && (
          <button
            onClick={() => handlePageChange(nextPageToken, "next")}
            className="mx-1 px-3 py-1 border rounded text-blue-500"
          >
            <img src={icons.nextPagination} className="w-3" alt="Next" />
          </button>
        )}
      </div>
    </div>
  );
};

export default StatusWiseAllLeads;
